import * as i from "react";
import { p as g } from "./index-efd35e77.js";
import { B as q } from "./Button-4c83e316.js";
import { w as b, D as ie, x as j, z as me } from "./index-93802845.js";
import { z as he } from "./index-a0534bb4.js";
import { Z as ve } from "./index-b1011fa6.js";
import { m as te, n as re, a as ae, b as ne } from "./index.es-6889c727.js";
import { l as de, v as ye } from "./index-64063129.js";
var T = function() {
  for (var o = [], a = 0; a < arguments.length; a++)
    o[a] = arguments[a];
  var e = {}, t = function(s) {
    return typeof s == "object" ? Object.keys(s).forEach(function(l) {
      e[l] = s[l];
    }) : e[s] = !0;
  }, n = function(s) {
    return s.filter(function(l) {
      return l !== !0 && !!l;
    }).map(function(l) {
      return Array.isArray(l) ? n(l) : t(l);
    });
  };
  return n(o), Object.keys(e).map(function(s) {
    return e[s] && s || null;
  }).filter(function(s) {
    return s !== null;
  }).join(" ");
};
function Me(o) {
  if (typeof de < "u")
    ye(o);
  else {
    var a = "License activation failed for ".concat(o.name, `
`);
    a += `The @progress/kendo-licensing script is not loaded.
`, a += "See ".concat(o.licensingDocsUrl, ` for more information.
`), console.warn(a);
  }
}
var le = {
  sizeMap: {
    small: "sm",
    medium: "md",
    large: "lg"
  },
  roundedMap: {
    small: "sm",
    medium: "md",
    large: "lg"
  }
}, r, S = "pager.info", _ = "pager.firstPage", L = "pager.previousPage", I = "pager.nextPage", C = "pager.lastPage", w = "pager.itemsPerPage", Oe = "pager.pageSelection", O = "pager.page", z = "pager.of", A = "pager.totalPages", Pe = "pager.pageLabel", k = "pager.ariaKeyshortcuts", N = "pager.ariaLabel", F = "pager.pageSizeAriaLabel", K = "pager.mobileSelect", x = "pager.moreButtonLabel", be = "filter.eqOperator", Ee = "filter.notEqOperator", Se = "filter.isNullOperator", _e = "filter.isNotNullOperator", Le = "filter.isEmptyOperator", Ie = "filter.isNotEmptyOperator", Ce = "filter.startsWithOperator", we = "filter.containsOperator", ze = "filter.notContainsOperator", Ae = "filter.endsWithOperator", ke = "filter.gteOperator", Ne = "filter.gtOperator", Fe = "filter.lteOperator", Ke = "filter.ltOperator", xe = "filter.isTrue", Te = "filter.isFalse", De = "filter.afterOrEqualOperator", qe = "filter.afterOperator", Re = "filter.beforeOperator", je = "filter.beforeOrEqualOperator", Be = "filter.andLogic", Ge = "filter.orLogic", We = "filter.addExpression", Ue = "filter.addGroup", $e = "filter.close", Ve = "filter.groupAriaLabel", Ze = "filter.expressionAriaLabel", He = "filter.expressionDropdownAriaLabel", Je = "filter.expressionOperatorDropdownAriaLabel", Qe = "filter.enumFilterDropdownAriaLabel", Xe = "filter.numericFilterAriaLabel", Ye = "filter.textFilterAriaLabel", et = "columnMenu.filterClearButton", tt = "columnMenu.filterSubmitButton", rt = "columnMenu.filterTitle", at = "columnMenu.sortAscending", nt = "columnMenu.sortDescending", st = "columnMenu.filterEqOperator", ot = "columnMenu.filterNotEqOperator", it = "columnMenu.filterIsNullOperator", lt = "columnMenu.filterIsNotNullOperator", pt = "columnMenu.filterIsEmptyOperator", ut = "columnMenu.filterIsNotEmptyOperator", gt = "columnMenu.filterStartsWithOperator", ct = "columnMenu.filterContainsOperator", ft = "columnMenu.filterNotContainsOperator", mt = "columnMenu.filterEndsWithOperator", ht = "columnMenu.filterGteOperator", vt = "columnMenu.filterGtOperator", dt = "columnMenu.filterLteOperator", yt = "columnMenu.filterLtOperator", Mt = "columnMenu.filterIsTrue", Ot = "columnMenu.filterAfterOrEqualOperator", Pt = "columnMenu.filterAfterOperator", bt = "columnMenu.filterBeforeOperator", Et = "columnMenu.filterBeforeOrEqualOperator", St = "columnMenu.filterAndLogic", _t = "columnMenu.filterOrLogic", Lt = "sort.ariaLabel", It = "filter.ariaLabel", c = (r = {}, r[w] = "items per page", r[Oe] = "Select page", r[S] = "{0} - {1} of {2} items", r[_] = "Go to the first page", r[L] = "Go to the previous page", r[I] = "Go to the next page", r[C] = "Go to the last page", r[O] = "Page", r[z] = "of", r[A] = "{0}", r[Pe] = "Page", r[k] = "Enter ArrowRight ArrowLeft", r[N] = "Pager", r[F] = "Page size", r[K] = "Select", r[x] = "More pages", r[Lt] = "Sortable", r[It] = "Filter", r[be] = "Is equal to", r[Ee] = "Is not equal to", r[Se] = "Is null", r[_e] = "Is not null", r[Le] = "Is empty", r[Ie] = "Is not empty", r[Ce] = "Starts with", r[we] = "Contains", r[ze] = "Does not contain", r[Ae] = "Ends with", r[ke] = "Is greater than or equal to", r[Ne] = "Is greater than", r[Fe] = "Is less than or equal to", r[Ke] = "Is less than", r[xe] = "Is true", r[Te] = "Is false", r[De] = "Is after or equal to", r[qe] = "Is after", r[Re] = "Is before", r[je] = "Is before or equal to", r[Be] = "And", r[Ge] = "Or", r[We] = "Add Expression", r[Ue] = "Add Group", r[$e] = "Close", r[Ve] = "Filter toolbar", r[Ze] = "Filter expression row", r[He] = "Filter dropdown", r[Je] = "Filter operator dropdown", r[Qe] = "Select True/False", r[Xe] = "Enter number", r[Ye] = "Enter text", r[et] = "Clear", r[tt] = "Filter", r[rt] = "Filter", r[at] = "Sort Ascending", r[nt] = "Sort Descending", r[st] = "Is equal to", r[ot] = "Is not equal to", r[it] = "Is null", r[lt] = "Is not null", r[pt] = "Is empty", r[ut] = "Is not empty", r[gt] = "Starts with", r[ct] = "Contains", r[ft] = "Does not contain", r[mt] = "Ends with", r[ht] = "Is greater than or equal to", r[vt] = "Is greater than", r[dt] = "Is less than or equal to", r[yt] = "Is less than", r[Mt] = "Is true", r[Ot] = "Is after or equal to", r[Pt] = "Is after", r[bt] = "Is before", r[Et] = "Is before or equal to", r[St] = "And", r[_t] = "Or", r), Ct = globalThis && globalThis.__extends || function() {
  var o = function(a, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(t, n) {
      t.__proto__ = n;
    } || function(t, n) {
      for (var s in n)
        Object.prototype.hasOwnProperty.call(n, s) && (t[s] = n[s]);
    }, o(a, e);
  };
  return function(a, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(a, e);
    function t() {
      this.constructor = a;
    }
    a.prototype = e === null ? Object.create(e) : (t.prototype = e.prototype, new t());
  };
}(), se = "...", wt = (
  /** @class */
  function(o) {
    Ct(a, o);
    function a() {
      var e = o !== null && o.apply(this, arguments) || this;
      return e.handlePageChange = function(t, n) {
        t.preventDefault(), e.props.pageChange(n, t);
      }, e.handleSelectPageChange = function(t) {
        t.preventDefault(), e.props.pageChange(t.target.value, t);
      }, e;
    }
    return a.prototype.render = function() {
      for (var e, t = this, n = b(this), s = this.props.messagesMap ? this.props.messagesMap(K) : { messageKey: K, defaultMessage: c[K] }, l = this.props.messagesMap ? this.props.messagesMap(O) : { messageKey: O, defaultMessage: c[O] }, u = this.props.messagesMap ? this.props.messagesMap(x) : { messageKey: x, defaultMessage: c[x] }, h = n.toLanguageString(u.messageKey, u.defaultMessage), v = this.start > 1 && this.renderDots(this.start - 1, h), y = this.end < this.props.totalPages && this.renderDots(this.end + 1, h), E = this.start > 1 && this.renderOptionDots(this.start - 1), P = this.end < this.props.totalPages && this.renderOptionDots(this.end + 1), M = [], p = this.start; p <= this.end; p++)
        M.push(p);
      var D = M.map(function(m) {
        return i.createElement(q, { className: T({ "k-selected": t.props.currentPage === m }), key: m, fillMode: "flat", themeColor: "primary", size: t.props.size, rounded: null, role: "button", "aria-label": n.toLanguageString(l.messageKey, l.defaultMessage) + " " + m, "aria-current": t.props.currentPage === m ? !0 : void 0, onClick: function(f) {
          return t.handlePageChange(f, m);
        } }, m);
      }), d = M.map(function(m) {
        return i.createElement("option", { key: m }, m);
      });
      return i.createElement(
        i.Fragment,
        null,
        i.createElement(
          "select",
          { style: { width: "5em", margin: "0px 1em", display: this.props.type === "dropdown" ? "inline-flex" : "none" }, className: T("k-picker k-dropdown-list k-dropdown k-rounded-md", (e = {}, e["k-picker-".concat(le.sizeMap[this.props.size] || this.props.size)] = this.props.size, e)), "aria-label": n.toLanguageString(s.messageKey, s.defaultMessage), value: this.props.currentPage, onChange: function(m) {
            return t.handleSelectPageChange(m);
          } },
          E,
          d,
          P
        ),
        i.createElement(
          "div",
          { className: "k-pager-numbers", style: { display: this.props.type === "numbers" ? "" : "none" } },
          v,
          D,
          y
        )
      );
    }, Object.defineProperty(a.prototype, "end", {
      get: function() {
        return Math.min(this.start + this.props.buttonCount - 1, this.props.totalPages);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(a.prototype, "start", {
      get: function() {
        var e = this.props.currentPage, t = this.props.buttonCount;
        if (e > t) {
          var n = e % t;
          return n === 0 ? e - t + 1 : e - n + 1;
        }
        return 1;
      },
      enumerable: !1,
      configurable: !0
    }), a.prototype.renderDots = function(e, t) {
      var n = this;
      return i.createElement(q, { fillMode: "flat", themeColor: "primary", size: this.props.size, rounded: null, role: "button", "aria-label": t, onClick: function(s) {
        return n.handlePageChange(s, e);
      } }, se);
    }, a.prototype.renderOptionDots = function(e) {
      return i.createElement("option", { value: e }, se);
    }, a;
  }(i.Component)
), zt = globalThis && globalThis.__extends || function() {
  var o = function(a, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(t, n) {
      t.__proto__ = n;
    } || function(t, n) {
      for (var s in n)
        Object.prototype.hasOwnProperty.call(n, s) && (t[s] = n[s]);
    }, o(a, e);
  };
  return function(a, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(a, e);
    function t() {
      this.constructor = a;
    }
    a.prototype = e === null ? Object.create(e) : (t.prototype = e.prototype, new t());
  };
}(), pe = (
  /** @class */
  function(o) {
    zt(a, o);
    function a() {
      var e = o !== null && o.apply(this, arguments) || this;
      return e.state = { page: e.props.currentPage }, e.handleOnChange = function(t) {
        e.setState({ page: t.target.value }), t.target.value && e.props.pageChange(t.target.value, t);
      }, e;
    }
    return a.prototype.render = function() {
      var e = ie(this), t = b(this), n = this.props.messagesMap ? this.props.messagesMap(O) : { messageKey: O, defaultMessage: c[O] }, s = this.props.messagesMap ? this.props.messagesMap(z) : { messageKey: z, defaultMessage: c[z] }, l = this.props.messagesMap ? this.props.messagesMap(A) : { messageKey: A, defaultMessage: c[A] };
      return i.createElement(
        i.Fragment,
        null,
        i.createElement(
          "span",
          { className: "k-pager-input" },
          i.createElement("span", null, t.toLanguageString(n.messageKey, n.defaultMessage)),
          i.createElement(he, { value: this.props.currentPage !== void 0 ? this.props.currentPage : this.state.page, onChange: this.handleOnChange, min: 1, spinners: !1 }),
          i.createElement("span", null, "".concat(t.toLanguageString(s.messageKey, s.defaultMessage), " ").concat(e.format(t.toLanguageString(l.messageKey, l.defaultMessage), [
            this.props.totalPages
          ])))
        )
      );
    }, a;
  }(i.Component)
);
j(pe);
var At = globalThis && globalThis.__extends || function() {
  var o = function(a, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(t, n) {
      t.__proto__ = n;
    } || function(t, n) {
      for (var s in n)
        Object.prototype.hasOwnProperty.call(n, s) && (t[s] = n[s]);
    }, o(a, e);
  };
  return function(a, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(a, e);
    function t() {
      this.constructor = a;
    }
    a.prototype = e === null ? Object.create(e) : (t.prototype = e.prototype, new t());
  };
}(), ue = (
  /** @class */
  function(o) {
    At(a, o);
    function a() {
      var e = o !== null && o.apply(this, arguments) || this;
      return e.pageSizeChange = function(t) {
        e.props.pageChange && e.props.pageChange({ skip: 0, take: parseInt(t.target.value, 10) }, t);
      }, e;
    }
    return a.prototype.render = function() {
      var e = this.props, t = e.value, n = e.pageSizes, s = e.pageSize, l = e.messagesMap, u = n.slice();
      t === void 0 && u.filter(function(y) {
        return y === s;
      }).length === 0 && u.unshift(s);
      var h = l ? l(w) : { messageKey: w, defaultMessage: c[w] }, v = l ? l(F) : { messageKey: F, defaultMessage: c[F] };
      return i.createElement(
        "span",
        { className: "k-pager-sizes" },
        i.createElement(ve, { value: t !== void 0 ? t : s, data: u, onChange: this.pageSizeChange, ariaLabel: b(this).toLanguageString(v.messageKey, v.defaultMessage), size: this.props.size }),
        i.createElement("span", null, b(this).toLanguageString(h.messageKey, h.defaultMessage))
      );
    }, a;
  }(i.Component)
);
j(ue);
var kt = {
  name: "@progress/kendo-react-data-tools",
  productName: "KendoReact",
  productCodes: ["KENDOUIREACT", "KENDOUICOMPLETE"],
  publishDate: 1695801765,
  version: "",
  licensingDocsUrl: "https://www.telerik.com/kendo-react-ui/my-license/?utm_medium=product&utm_source=kendoreact&utm_campaign=kendo-ui-react-purchase-license-keys-warning"
}, Nt = globalThis && globalThis.__extends || function() {
  var o = function(a, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(t, n) {
      t.__proto__ = n;
    } || function(t, n) {
      for (var s in n)
        Object.prototype.hasOwnProperty.call(n, s) && (t[s] = n[s]);
    }, o(a, e);
  };
  return function(a, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(a, e);
    function t() {
      this.constructor = a;
    }
    a.prototype = e === null ? Object.create(e) : (t.prototype = e.prototype, new t());
  };
}(), R = globalThis && globalThis.__assign || function() {
  return R = Object.assign || function(o) {
    for (var a, e = 1, t = arguments.length; e < t; e++) {
      a = arguments[e];
      for (var n in a)
        Object.prototype.hasOwnProperty.call(a, n) && (o[n] = a[n]);
    }
    return o;
  }, R.apply(this, arguments);
}, oe = 600, Ft = 768, ge = (
  /** @class */
  function(o) {
    Nt(a, o);
    function a(e) {
      var t = o.call(this, e) || this;
      return t._element = null, t.onPageChange = function(n, s) {
        var l = R({ target: t, syntheticEvent: s.syntheticEvent, nativeEvent: s.nativeEvent, targetEvent: s }, n);
        t.props.onPageChange && t.props.onPageChange.call(void 0, l);
      }, t.changePage = function(n, s) {
        t.props.onPageChange && n > 0 && n <= t.totalPages && t.props.onPageChange({
          target: t,
          skip: (n - 1) * t.props.take,
          take: t.props.take,
          syntheticEvent: s,
          nativeEvent: s.nativeEvent,
          targetEvent: s
        });
      }, t.onWindowResize = function() {
        var n = t.element;
        if (!(!n || !t.props.responsive)) {
          var s = n.offsetWidth;
          s < oe ? t.setState({ showPagerSizes: !1 }) : s >= oe && s < Ft ? t.setState({ showPagerInfo: !1, showPagerSizes: !0 }) : t.setState({ showPagerInfo: !0, showPagerSizes: !0 });
        }
      }, Me(kt), t.state = { showPagerSizes: !0, showPagerInfo: !0 }, t;
    }
    return Object.defineProperty(a.prototype, "isRtl", {
      get: function() {
        return this.props.dir === "rtl";
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(a.prototype, "element", {
      /**
       * Returns the HTML element of the Pager component.
       */
      get: function() {
        return this._element;
      },
      enumerable: !1,
      configurable: !0
    }), a.prototype.componentDidMount = function() {
      window.addEventListener("resize", this.onWindowResize), this.onWindowResize();
    }, a.prototype.componentWillUnmount = function() {
      window.removeEventListener("resize", this.onWindowResize);
    }, a.prototype.render = function() {
      var e, t = this, n = this.state, s = n.showPagerSizes, l = n.showPagerInfo, u = this.props, h = u.skip, v = u.take, y = u.total, E = u.pageSizes, P = u.size, M = u.responsive, p = u.messagesMap, D = u.pageSizeValue, d = b(this), m = ie(this), f = Math.floor(h / v) + 1, ce = this.props.type === "numeric" ? i.createElement(wt, { type: M && !s ? "dropdown" : "numbers", buttonCount: this.props.buttonCount || 0, totalPages: this.totalPages, currentPage: f, pageChange: this.changePage, messagesMap: this.props.messagesMap, size: this.props.size }) : i.createElement(pe, { buttonCount: this.props.buttonCount || 0, totalPages: this.totalPages, currentPage: f, pageChange: this.changePage, messagesMap: p, size: this.props.size }), B = p ? p(_) : { messageKey: _, defaultMessage: c[_] }, G = p ? p(L) : { messageKey: L, defaultMessage: c[L] }, W = p ? p(I) : { messageKey: I, defaultMessage: c[I] }, U = p ? p(C) : { messageKey: C, defaultMessage: c[C] }, $ = p ? p(S) : { messageKey: S, defaultMessage: c[S] }, V = p ? p(k) : { messageKey: k, defaultMessage: c[k] }, Z = p ? p(N) : { messageKey: N, defaultMessage: c[N] }, H, J, Q, X;
      this.props.previousNext && (H = this.renderButton(1, "k-pager-nav k-pager-first" + (f === 1 ? " k-disabled" : ""), d.toLanguageString(B.messageKey, B.defaultMessage), this.isRtl ? "caret-alt-to-right" : "caret-alt-to-left", this.isRtl ? te : re, f === 1 ? !0 : void 0), J = this.renderButton(f - 1, "k-pager-nav" + (f === 1 ? " k-disabled" : ""), d.toLanguageString(G.messageKey, G.defaultMessage), this.isRtl ? "caret-alt-right" : "caret-alt-left", this.isRtl ? ae : ne, f === 1 ? !0 : void 0), Q = this.renderButton(f + 1, "k-pager-nav" + (f >= this.totalPages ? " k-disabled" : ""), d.toLanguageString(W.messageKey, W.defaultMessage), this.isRtl ? "caret-alt-left" : "caret-alt-right", this.isRtl ? ne : ae, f >= this.totalPages ? !0 : void 0), X = this.renderButton(this.totalPages, "k-pager-nav k-pager-last" + (f >= this.totalPages ? " k-disabled" : ""), d.toLanguageString(U.messageKey, U.defaultMessage), this.isRtl ? "caret-alt-to-left" : "caret-alt-to-right", this.isRtl ? re : te, f >= this.totalPages ? !0 : void 0));
      var Y = E && i.createElement(ue, { pageChange: this.onPageChange, pageSize: v, pageSizes: E, value: D, messagesMap: p, size: this.props.size }), ee = this.props.info && i.createElement("span", { className: "k-pager-info" }, m.format(d.toLanguageString($.messageKey, $.defaultMessage), [
        Math.min(h + 1, y),
        Math.min(h + v, y),
        y
      ]));
      return i.createElement(
        "div",
        { className: T("k-pager", (e = {}, e["k-pager-".concat(le.sizeMap[P] || P)] = P, e), this.props.className), style: this.props.style, role: "application", "aria-roledescription": "pager", dir: this.props.dir, "aria-keyshortcuts": d.toLanguageString(V.messageKey, V.defaultMessage), "aria-label": d.toLanguageString(Z.messageKey, Z.defaultMessage), ref: function(fe) {
          return t._element = fe;
        } },
        i.createElement(
          "div",
          { className: T("k-pager-numbers-wrap") },
          H,
          J,
          ce,
          Q,
          X
        ),
        M ? s && Y : Y,
        M ? l && ee : ee
      );
    }, a.prototype.renderButton = function(e, t, n, s, l, u) {
      var h = this;
      return i.createElement(q, { fillMode: "flat", themeColor: "base", size: this.props.size, rounded: null, className: t, icon: s, svgIcon: l, title: n, role: "button", "aria-disabled": u, onClick: function(v) {
        v.preventDefault(), h.changePage(e, v);
      } });
    }, Object.defineProperty(a.prototype, "totalPages", {
      get: function() {
        return Math.ceil((this.props.total || 0) / this.props.take);
      },
      enumerable: !1,
      configurable: !0
    }), a.propTypes = {
      className: g.string,
      style: g.object,
      total: g.number.isRequired,
      skip: g.number.isRequired,
      take: g.number.isRequired,
      buttonCount: g.number,
      info: g.bool,
      type: g.oneOf(["numeric", "input"]),
      pageSizes: g.arrayOf(g.oneOfType([
        g.string,
        g.number
      ])),
      previousNext: g.bool,
      onPageChange: g.func,
      messagesMap: g.func,
      size: g.oneOf([null, "small", "medium", "large"]),
      dir: g.string
    }, a.defaultProps = {
      buttonCount: 10,
      info: !0,
      type: "numeric",
      size: "medium"
    }, a;
  }(i.Component)
);
me(ge);
j(ge);
export {
  ge as P,
  T as c
};
